import { ACCOUNTING_METHOD_SELECTION_MODAL_PATH } from '../accounting_method_selection/Constants';

export const FREE_TRIAL_UPGRADE_MODAL_PATH = 'free-trial-upgrade';
export const FREE_TRIAL_SETTINGS_MODAL_PATH = 'free-trial-settings';

export const FREE_TRIAL_NAVBAR_ROUTE_STRIP_SEGMENTS = [
  ACCOUNTING_METHOD_SELECTION_MODAL_PATH,
  'inbox',
  'scans',
  'new-signup',
  'free-trial',
  FREE_TRIAL_UPGRADE_MODAL_PATH,
  FREE_TRIAL_SETTINGS_MODAL_PATH,
];
